import { createComponent } from "@helpers/admin";
import HeroSectionComponent from "@template/blocks/HeroSection/component";
import fieldTypes from "../overrides/fieldTypes";

export const Hero = createComponent({
  label: "Hero",
  component: HeroSectionComponent,
  resolveFields: async (data) => {
    const basicBlock = data?.props?.needBasicBlock && {
      basicBlock: {
        label: "Basic Block",
        type: "object" as const,
        objectFields: {
          heading: {
            label: "Heading",
            type: "textarea" as const,
          },
          backgroundColor: {
            label: "Background Color",
            type: "select" as const,
            options: [
              { label: "Grey", value: "grey" },
              { label: "Burgundy", value: "burgundy" },
              { label: "White", value: "white" },
            ],
          },
          image: {
            label: "Image",
            type: "image" as const,
          },
          isParagraph: {
            label: "Is Paragraph",
            type: "boolean" as const,
          },
          content: {
            label: "Content",
            type: "markdown" as const,
          },
          bullets: {
            label: "Bullet Points",
            type: "array" as const,
            arrayFields: {
              text: {
                type: "textarea" as const,
                label: "Text",
              },
            },
          },
          buttons: {
            label: "Buttons",
            type: "array" as const,
            arrayFields: {
              children: {
                label: "Text",
                type: "textarea" as const,
              },
              link: {
                label: "Link",
                type: "text" as const,
              },
              variant: {
                label: "Variant",
                type: "select" as const,
                options: [
                  { label: "Flat", value: "flat" },
                  { label: "Solid", value: "solid" },
                  { label: "Outline", value: "outline" },
                ],
              },
              target: {
                label: "Open In New Tab",
                type: "select" as const,
                options: [
                  { label: "Yes", value: "_blank" },
                  { label: "No", value: "_self" },
                ],
              },
              color: {
                label: "Color",
                type: "select" as const,
                options: [
                  { label: "Default", value: "default" },
                  { label: "Primary", value: "primary" },
                  { label: "Secondary", value: "secondary" },
                  { label: "Success", value: "success" },
                ],
              },
              title: {
                label: "Title",
                type: "textarea" as const,
              },
            },
          },
          flip: {
            label: "Flip Content and Image",
            type: "boolean" as const,
          },
        },
      },
    };
    return {
      heading: {
        label: "Heading",
        type: "textarea",
        default: "Heading",
      },
      subHeading: {
        label: "Sub Heading",
        type: "markdown",
        // default: "Sub Heading",
      },
      needBasicBlock: {
        label: "Need Basic Block",
        type: "boolean",
        tooltip:
          "If enabled, you can add a basic block within the hero section to include additional content such as text, images, or videos. This allows for greater flexibility and customization of the hero section, enabling you to create a more engaging and informative experience for your visitors.",
      },
      ...basicBlock,
      image: {
        label: "Image",
        type: "image",
      },
      heroFooterImage: {
        label: "Hero Footer Image",
        type: "custom",
        instructionText:
          "Standard Hero Image: 1200px x 700px <br/> Short Hero Image: 1224px x 440px <br/> Default height: 700px <br/> Default width: 1200px",
        render: fieldTypes.advanceImage,
      },
      buttons: {
        label: "Buttons",
        type: "array",
        arrayFields: {
          children: {
            label: "Text",
            type: "textarea",
          },
          link: {
            label: "Link",
            type: "text",
          },
          variant: {
            label: "Variant",
            type: "select",
            options: [
              { label: "Flat", value: "flat" },
              { label: "Solid", value: "solid" },
              { label: "Outline", value: "outline" },
            ],
          },
          target: {
            label: "Open In New Tab",
            type: "select",
            options: [
              { label: "Yes", value: "_blank" },
              { label: "No", value: "_self" },
            ],
          },
          color: {
            label: "Color",
            type: "select",
            options: [
              { label: "Default", value: "default" },
              { label: "Primary", value: "primary" },
              { label: "Secondary", value: "secondary" },
              { label: "Success", value: "success" },
            ],
          },
          title: {
            label: "Title",
            type: "textarea",
          },
        },
      },
      badges: {
        label: "Badges",
        type: "array",
        arrayFields: {
          link: {
            type: "textarea",
            label: "Link",
          },
          target: {
            label: "Destination Type",
            type: "radio",
            options: [
              {
                label: "New Tab",
                value: "_blank",
              },
              {
                label: "Same Tab",
                value: "_self",
              },
            ],
          },
          image: {
            label: "Image",
            type: "image",
          },
        },
      },
      reviews: {
        label: "Show Reviews",
        type: "boolean",
      },
      column: {
        label: "Column Layout",
        type: "boolean",
      },
      altStyling: {
        label: "Alternative Styling",
        type: "boolean",
      },
      greyBackground: {
        label: "Grey Background",
        type: "boolean",
      },
    };
  },
});
